import { PVZRepository } from '../repositories/pvz.repository'
import {
    PVZGetListResponseT,
    PVZGetParamsT,
    PVZUpdateParamsT,
    InvoicesGetParamsT,
    InvoicesGetListResponseT,
    PVZCreateParamsT,
    PVZGetByIDResponseT,
} from '../types/pvz.types'

const pvzRepository = new PVZRepository()

export class PVZService {
    async getPVZByID(distribution_center_id: number): Promise<PVZGetByIDResponseT> {
        const response = await pvzRepository.getPVZByID(distribution_center_id)
        return response.data
    }

    async getList(params: PVZGetParamsT): Promise<PVZGetListResponseT> {
        const response = await pvzRepository.getList(params)
        return response.data
    }

    async updatePVZInfo(params: PVZUpdateParamsT): Promise<void> {
        await pvzRepository.updatePVZInfo(params)
    }

    async createPVZ(payload: PVZCreateParamsT): Promise<void> {
        await pvzRepository.createPVZ(payload)
    }

    async deletePVZ(id: number): Promise<void> {
        await pvzRepository.deletePVZ(id)
    }

    async getInvoicesList(params: InvoicesGetParamsT): Promise<InvoicesGetListResponseT> {
        const response = await pvzRepository.getInvoicesList(params)
        return response.data
    }

    async addUser(pvz_id: number, payload: any): Promise<void> {
        await pvzRepository.addUser(pvz_id, payload)
    }

    async uploadPhoto(pvz_id: number, form_data: FormData): Promise<void> {
        await pvzRepository.uploadPhoto(pvz_id, form_data)
    }
}
